export default {"src":"/_next/static/media/auth-toast-success-icon.7c445e45.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};